allowedPaths